/**
 * Exempt Private Company Certificate (Section 260 & 261, M32016) mapper.
 */
import { formatMyAddressLine } from '@/shared/utils/malaysianAddress';
import { typeOf } from '../components/exemptPrivateCompany/epcFields';

import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';

export interface EpcState {
  values: Record<string, string>;
  signers: SignerEntry[];
}

export function emptyEpcState(): EpcState {
  return { values: {}, signers: [] };
}

export function buildEpcVariables(state: EpcState): Record<string, any> {
  const out: Record<string, any> = {};
  for (const [k, v] of Object.entries(state.values || {})) {
    const raw = v ?? '';
    out[k] = typeOf(k) === 'address' ? formatMyAddressLine(String(raw)) : raw;
  }
  return out;
}
